/* global WHITELABEL */
import con from '@services/connection'
import { resumoCliente } from '@constants/URL'
import store from '@state/store'
import moment from 'moment'

/**
 * Verificar se ja passou certo tempo da data
 * @param {Date} date Data base para comparacao
 * @param {Number} min Tempo minimo considerado
 * @returns {Boolean} Passou mais de <min> minutos de <date>
 */
const hasDiff = (date, min) => {
  if (!date) {
    return true
  }
  return new Date() - date >= min * 60000
}

/**
 * Coleta dos dados e formatacao da estrutura para o resumo do cliente
 * @param {Object} cliente Objeto do cliente que será buscado
 * @param {Object} commit commit do vuex
 */
const loadDados = async (cliente, commit) => {
  // Iniciando loading para este cliente
  commit('SET_LOADING_DADOS', { loading: true, id_cliente: cliente.id })
  commit('SET_LOADING_ESTRUTURA', { loading: true, id_cliente: cliente.id })

  // Limpando os dados antigos
  commit('CLEAR_DADOS')
  commit('CLEAR_ESTRUTURA')

  // Declaracao das partes buscadas
  const partes = [
    'assets_due_date',
    'client_data',
    'portfolio_review_data',
    'subscriptions',
    'ips_data',
    'financial_data',
    'revenue_data',
    'invites_data',
  ]

  // Chamada para o servidor com as partes e o cliente
  const r = await con.get(
    `${resumoCliente.dados}${cliente.id}?summary_parts=${partes.join(',')}`
  )

  if (r && r.status === 200) {
    // Formatacao da estrutura para o processo do resumo
    const estrutura = {}

    // Passo: Convite App - verificar se possui data de registro
    estrutura.data_registro = moment(
      r.value.client_data.data_registro,
      'DD/MM/YYYY HH:mm'
    ).format('DD/MM/YYYY')
    if (estrutura.data_registro === 'Invalid date') {
      estrutura.data_registro = ''
    }

    estrutura.acesso_realizado = r.value.client_data.ultimo_acesso_app

    const convite = (r.value.invites_data || []).find((c) => {
      return !['Aguardando link parceria'].includes(c.status)
    })
    estrutura.envio_convite = !!convite

    if (r.value.subscriptions && r.value.subscriptions.active) {
      const first_service = r.value.subscriptions.active.sort((a, b) => {
        return a.data_contratacao_em_dias < b.data_contratacao_em_dias ? 1 : -1
      })[0]

      if (first_service) {
        estrutura.servico = first_service.id_servico
        estrutura.servico_nome = first_service.nome_servico
        estrutura.servico_dias_atras = moment(
          first_service.data_contratacao,
          'DD/MM/YYYY HH:mm'
        ).fromNow()
        if (estrutura.servico_dias_atras === 'Invalid date') {
          estrutura.servico_dias_atras = ''
        }
      }
    }

    const next_asset = r.value.assets_due_date.sort((a, b) => {
      return a.dias_para_vencimento < b.dias_para_vencimento ? 1 : -1
    })[0]
    if (next_asset) {
      estrutura.ativo_proximo_vencimento = moment(
        next_asset.data_vencimento,
        'DD/MM/YYYY'
      ).fromNow()
      if (estrutura.ativo_proximo_vencimento === 'Invalid date') {
        estrutura.ativo_proximo_vencimento = ''
      }
    }

    if (r.value.ips_data) {
      estrutura.revisao_ips = moment(
        r.value.ips_data.data_para_prox_ips,
        'DD/MM/YYYY'
      ).fromNow()
      if (estrutura.revisao_ips === 'Invalid date') {
        estrutura.revisao_ips = ''
      }
    }

    if (r.value.portfolio_review_data) {
      estrutura.revisao_simulacao = moment(
        r.value.portfolio_review_data.prox_portfolio_review,
        'DD/MM/YYYY'
      ).fromNow()
      if (estrutura.revisao_simulacao === 'Invalid date') {
        estrutura.revisao_simulacao = ''
      }
    }

    // Salvando estrutura para a linha do processo do resumo
    commit('SET_ESTRUTURA', { estrutura: estrutura, cliente: cliente })
    // Salvando dados do cliente
    commit('SET_DADOS', { dados: r.value, cliente: cliente })
  }

  // Parando loading para o cliente especifico
  commit('SET_LOADING_DADOS', { loading: false, id_cliente: cliente.id })
  commit('SET_LOADING_ESTRUTURA', { loading: false, id_cliente: cliente.id })
}

const carregar = ({ commit }, cliente) => {
  const info = store.getters['clientStatus/infoDados']

  // Se esta carregando os dados para este cliente interrompe nova chamada
  if (cliente.id === info.id_cliente && info.loading) {
    console.log('Já está carregando os dados')
    return
  }

  // Se carregou os dados deste cliente nos ultimos 5 minutos interrompe nova chamada
  if (cliente.id === info.id_cliente && !hasDiff(info.data_coleta, 5)) {
    console.log('Dados coletados recentemente')
    return
  }

  if (store.getters['user/currentUser'].IS_CLIENTE) {
    console.log('Acesso bloqueado para clientes')
    return
  }

  if (!WHITELABEL) {
    console.log('Acesso bloqueado para não-whitelabel')
    return
  }

  loadDados(cliente, commit)
}

export { carregar }
